import { render, staticRenderFns } from "./wxpay.vue?vue&type=template&id=73996432&scoped=true"
import script from "./wxpay.vue?vue&type=script&lang=js"
export * from "./wxpay.vue?vue&type=script&lang=js"
import style0 from "./wxpay.css?vue&type=style&index=0&id=73996432&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73996432",
  null
  
)

export default component.exports